import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { NavbarContainer, Footer } from 'sarsaparilla';

if (process.env.A11Y_ENABLED) {
  const a11y = require('react-a11y-alt').default; // eslint-disable-line global-require
  a11y(React, ReactDOM, {
    rules: {
      'img-uses-alt': 'warn',
      'redundant-alt': ['warn', ['image', 'photo', 'foto', 'bild']],
      'button-role-space': 'warn',
      'hidden-uses-tabindex': 'warn',
      'label-uses-for': 'warn',
      'mouse-events-map-to-key-events': 'warn',
      'no-access-key': 'warn',
      'no-hash-ref': 'warn',
      'no-unsupported-elements-use-aria': 'warn',
      'onclick-uses-role': 'warn',
      'onclick-uses-tabindex': 'warn',
      'tabindex-uses-button': 'warn',
      'use-onblur-not-onchange': 'warn'
    }
  });
}

class App extends React.Component {
  render() {
    return (
      <div className="parkpass">
        <div className="rec-page">
          <div className="page-body">
            <NavbarContainer location={this.props.location} />
            <div
              className="page-content"
              id="page-content"
              role="main">
              {this.props.children}
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.node
};

function mapStateToProps(state) {
  return Object.assign({}, state);
}

export default connect(mapStateToProps)(App);
